import { jwtDecode } from 'jwt-decode'

import type { Jwt } from '@app/models'

export const getUserIdFromToken = (
  token: string | null | undefined
): number | null => {
  if (!token) {
    return null
  }

  try {
    const decoded = jwtDecode<Jwt>(token)

    return decoded?.user_id && decoded?.auth_state === 'UserAuthenticated'
      ? parseInt(decoded.user_id, 10)
      : null
  } catch (error) {
    console.error('Error decoding access token', error)

    return null
  }
}
